import React, { Component } from 'react';
import {Link} from 'react-router-dom';
class Slider extends Component {
  constructor() {
    super();
    this.state = {
    };
  }


  componentDidMount() {
       }


  render() {
    return (
         <div className="container-fluid p-0 dis_flex">

     <div className="left_con">
            <div className="owl-carousel header-carousel position-relative">
                <div className="owl-carousel-item position-relative">
                    <img className="img-fluid" src="./assets/img/slider/carousel-0.png" alt=""/>
                </div>
                <div className="owl-carousel-item position-relative">
                    <img className="img-fluid" src="./assets/img/slider/carousel-2.png" alt="" />
                </div>
                <div className="owl-carousel-item position-relative">
                    <img className="img-fluid" src="./assets/img/slider/carousel-1.png" alt="" />
                </div>
            </div>
      </div>




        </div>
    );
  }
}

export default Slider;
